<template>
    <div class="flex flex-wrap">
      <div class="w-full lg:w-12/12 px-4">
        <CardImport/>
      </div>
    </div>
  </template>
  